module.exports = __webpack_public_path__ + "img/evergreen-card.9fa7cf05.jpg";